import { copyAllProperties } from "./utils";

export class DeviceClass {
  name: string = "";
  description = { en: "" };

  constructor(data?: any) {
    copyAllProperties(data, this);
  }

  toString() {
    return this.description.en;
  }

  toJSON() {
    return { name: this.name };
  }

  fromJSON(data: any): any {
    return DeviceClasses.deviceClassFromString(data.name);
  }
}
export class DeviceClasses {
  static Unknown = new DeviceClass({
    name: "Unknown",
    description: { en: "Unknown" },
  });

  static Actor = new DeviceClass({
    name: "Actor", // no itx
    description: { en: "Actor" }, // no itx
  });

  static Button = new DeviceClass({
    name: "Button", // no itx
    description: { en: "Button" }, // no itx
  });
  // cant be named Sensor -> crash
  static SensorNew = new DeviceClass({
    name: "SensorNew", // no itx
    description: { en: "Sensor" }, // no itx
  });

  static DecentralActor = new DeviceClass({
    name: "DecentralActor", // no itx
    description: { en: "DecentralActor" }, // no itx
  });

  // static Gateway = new DeviceClass({
  //   name: "Gateway", // no itx
  //   description: { en: "Gateway" }, // no itx
  // });

  // static Other = new DeviceClass({
  //   name: "Other", // no itx
  //   description: { en: "Other" }, // no itx
  // });

  // static ButtonActor = new DeviceClass({
  //   name: "ButtonActor", // no itx
  //   description: { en: "ButtonActor" }, // no itx
  // });

  static CableType = new DeviceClass({
    name: "CableType", // no itx
    description: { en: "CableType" }, // no itx
  });

  static deviceClassFromString(sType: string): DeviceClass {
    switch (sType) {
      case "Actor": // no itx
        return this.Actor;
        break;
      case "Button": // no itx
        return this.Button;
        break;
      case "SensorNew": // no itx
        return this.SensorNew;
        break;
      // case "Gateway": // no itx
      //   return this.Gateway;
      //   break;
      // case "Other": // no itx
      //   return this.Other;
      //   break;
      // case "ButtonActor": // no itx
      //   return this.ButtonActor;
      //   break;
      case "DecentralActor": // no itx
        return this.DecentralActor;
        break;
      case "CableType": // no itx
        return this.CableType;
        break;
      default:
        return this.Unknown;
    }
  }
}
